// extracted by mini-css-extract-plugin
export default {"button":"Mv3epP","primary":"JjeNJn","secondary":"dhXnmw","mini":"T7AUyd","pill":"PWWto6","hover":"CGootV","active":"s5x0pS","disabled":"GuwyyR"};